import { render, staticRenderFns } from "./Classroom_new_video_detial.vue?vue&type=template&id=362ccfc6&scoped=true"
import script from "./Classroom_new_video_detial.vue?vue&type=script&lang=js"
export * from "./Classroom_new_video_detial.vue?vue&type=script&lang=js"
import style0 from "./Classroom_new_video_detial.vue?vue&type=style&index=0&id=362ccfc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362ccfc6",
  null
  
)

export default component.exports